
import { defineComponent } from 'vue'
import Dialog from 'primevue/dialog'
import schedulerTimingOutputDetailDialogDescriptor from './SchedulerTimingOutputDetailDialogDescriptor.json'

export default defineComponent({
    name: 'scheduler-timing-output-warning-dialog',
    components: { Dialog },
    props: {
        visible: { type: Boolean },
        warningTitle: { type: String },
        warningMessage: { type: String }
    },
    emits: ['close'],
    data() {
        return {
            schedulerTimingOutputDetailDialogDescriptor
        }
    },
    created() {},
    methods: {}
})
